import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { initGA, trackPageView } from '@/lib/analytics';

/**
 * <Analytics /> — mounted once inside <BrowserRouter> in App.js.
 *
 *  - Initializes GA4 on first mount (loads gtag.js exactly once).
 *  - Fires `page_view` on every react-router location change (SPA nav).
 *  - Uses `send_page_view: false` in config so the initial load ALSO comes
 *    from this effect — no double-firing.
 *
 * Renders nothing.
 */
const Analytics = () => {
  const location = useLocation();

  // Boot GA4 once on first mount.
  useEffect(() => {
    initGA();
  }, []);

  // Fire page_view on every route change (including initial mount).
  useEffect(() => {
    const path = location.pathname + location.search;
    // Small microtask delay so document.title (set by react-helmet-async
    // via <Seo />) is up to date for the page we just navigated to.
    const t = setTimeout(() => trackPageView(path), 0);
    return () => clearTimeout(t);
  }, [location.pathname, location.search]);

  return null;
};

export default Analytics;
